import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 7],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Directivity map for <span style='font-weight: 600; font-style:italic; letter-spacing:normal'>N = 20</span> and <span style='font-weight: 600; font-style:italic; letter-spacing:normal; text-transform: none;'>d = 20cm</span>",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 2,
                      rows: 2,
                      rowsSize: [1, 2],
                      gap: "0 3%",
                      colSpan: {
                        "1:0": 2,
                      },
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                    <li style="font-size: 14px">Directivity increases<br>with frequency
                                    <li style="font-size: 14px">First love appears for <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                                        <mi>f</mi>
                                        <mo>=</mo>
                                        <mfrac>
                                          <mrow>
                                              <mi>c</mi>
                                          </mrow>
                                          <mrow>
                                              <mi>dN</mi>
                                          </mrow>
                                        </mfrac>
                                    </math>
                                  </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                },
                              },
                              styles: {
                                justifyContent: "flex-end",
                                alignItems: "flex-start",
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>


                                  <li style="font-size: 14px">Number of lobes increases<br>with frequency
                                  <li style="font-size: 14px">Aliasing appears for <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                                      <mi>f</mi>
                                      <mo>></mo>
                                      <mi>c</mi>
                                      <mo>/</mo>
                                      <mi>d</mi>
                                  </math>
                                </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                },
                              },
                              styles: {
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "image",
                                options: {
                                  src: `${config.ASSETS_URL}/04/28/principle/principle-2.svg`,
                                },
                              },
                              styles: {
                                padding: "2%",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["default"]}`,
                      borderRadius: "10px",
                      padding: "0 3%",
                    },
                  },
                },
              },
              styles: {
                padding: "6% 2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
